
























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { NewsInstanceGroup } from "@/services/news/types";
import { getNewsInstanceGroups } from "@/services/news/newsService";
import { selectInstanceGroupsFields } from "@/components/news/fields/selectInstanceGroupsFields";
import SelectInstanceGroupsModal from "@/components/news/modals/SelectInstanceGroupsModal.vue";
import NewsInstanceGroupsDeleteModal from "@/components/news/modals/NewsInstanceGroupsDeleteModal.vue";
@Component({
    components: { NewsInstanceGroupsDeleteModal, SelectInstanceGroupsModal }
})
export default class NewsInstanceGroups extends Vue {
    @Prop() newsId!: string;
    @Prop() collapseState!: boolean;
    // local state
    localNewsId = "";
    newsInstanceGroups = [] as NewsInstanceGroup[];
    searchQuery = "";
    fields = selectInstanceGroupsFields;
    localCollapseState = true;

    // watchers
    @Watch("newsId")
    onPropertyChanged() {
        this.localNewsId = this.newsId;
        this.fetchData();
    }

    // lifecycle hooks

    // computed
    get filteredData() {
        return this.newsInstanceGroups && this.newsInstanceGroups
            .filter(x => this.searchQuery.length === 0 ||
                (x.name.toLowerCase().includes(this.searchQuery.toLowerCase())));
    }

    // methods
    fetchData() {
        getNewsInstanceGroups(this.localNewsId).then(response => {
            this.newsInstanceGroups = response;
        });
    }

    openInstanceGroupsPrompt() {
        (this.$refs.selectInstanceGroups as any).open(true);
    }

    setState(state: boolean) {
        if (this.localCollapseState === state) return;

        this.localCollapseState = state;
    }

    onInstanceGroupSelected(instanceGroups: NewsInstanceGroup[]) {
        const instanceGroupsToBeAdded = instanceGroups
            .filter(x => !this.newsInstanceGroups.map(x => x.instanceGroupId).includes(x.instanceGroupId));
        if (instanceGroupsToBeAdded.length > 0) {
            this.newsInstanceGroups = this.newsInstanceGroups.concat(instanceGroupsToBeAdded);
        }
    }

    removeInstanceGroup(instanceGroup: NewsInstanceGroup) {
        (this.$refs.deleteInstanceGroup as any).open(instanceGroup.instanceGroupId, instanceGroup.name);
    }

    onDeleted(id: string) {
        const item = this.newsInstanceGroups.find(x => x.instanceGroupId === id);
        if (!item) {
            return;
        }
        this.newsInstanceGroups = this.newsInstanceGroups.filter(x => x.instanceGroupId !== id);
    }

    // events
    emitData() {
        this.$emit("instanceGroupsUpdated", this.newsInstanceGroups.map(x => x.instanceGroupId));
    }
}
